// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1YYMU","Success":"Button_Success__3GhS8","Danger":"Button_Danger__3oTBU"};